























import { Button, Field, Form, Popup, Toast } from "vant";
import PopupHeader from "@/views/h5-page/account/Component/PopupHeader.vue";

export default {
  name: "LinkAccount",
  components: {
    PopupHeader,
    [Popup.name]: Popup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    overlay: {
      type: Boolean,
      default: true
    },
    result: {
      type: Object
    }
  },
  computed: {
    enable(): boolean {
      const password = (this as any).password;
      return password !== null && password.length > 0;
    }
  },
  data() {
    return {
      password: "",
      error: "",
      isShow: false,
      newResult: {}
    };
  },
  methods: {
    close() {
      (this as any).password = "";
      (this as any).error = "";
      (this as any).isShow = false;
      (this as any).$emit("close");
    },
    submit() {
	  Toast.resetDefaultOptions();	
      const data = {
        account: (this as any).newResult.u_user_id,
        password: (this as any).password
      };
      //
      (this as any).$apis
        .accountConnext(data)
        .then(res => {
          
          
          if ((this as any).newResult.type == undefined || (this as any).newResult.type == 0) {
            this.close();
            (this as any).$emit("success");
            Toast("链接成功");
          } else if ((this as any).newResult.type == 1) {
            const data = {
              futures_login_id: (this as any).newResult.u_user_id,
              password: (this as any).password,
              id:(this as any).newResult.id
            };
            (this as any).$apis
              .addgroupTrade(data)
              .then(res => {
                Toast("添加成功");
                this.close();
                (this as any).password="";
                (this as any).$emit("success");
              })
              .catch(e => {
                
              });
          }
        })
        .catch(e => {
          
        });
    }
  },
  watch: {
    show(newVal) {
      
      (this as any).isShow = newVal;
    },
    result(newVal) {
      
      (this as any).newResult = newVal;
    }
  }
};
